import { Stacked } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import { RADAR_VIEW, radarViewAtom } from '@/atoms/radar';
import { RadarDataFormatToggle } from './RadarDataFormatToggle';
import { RadarViewToggle } from './RadarViewToggle';

export const RadarCardHeader = () => {
  const isDistributionView = useAtomValue(radarViewAtom) === RADAR_VIEW.DISTRIBUTION;

  return (
    <Stacked justifyContent="space-between" testId="radar-card-header">
      <RadarViewToggle />
      {!isDistributionView && <RadarDataFormatToggle />}
    </Stacked>
  );
};
